var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooklaBusinessLogoSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8.88889,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000183105,
    width: 32,
    height: 32,
    fill: "#53639B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1562 2.99637C53.2203 12.135 33.8028 20.4046 30.1635 25.6282C24.2939 34.0533 26.1744 44.4416 17.0157 45.5159C2.72716 47.1919 1.77512 28.3996 17.9511 11.4768C27.8271 1.1448 33.7954 -5.50363 43.1562 2.99637Z",
    fill: "#7180B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0387 18.3609C54.6631 22.9086 38.1439 29.6429 34.9405 33.1321C29.7737 38.76 31.4732 44.919 24.5551 46.4334C13.762 48.7961 11.1966 36.3046 24.839 24.5848C33.1681 17.4295 41.8773 14.131 48.0387 18.3609Z",
    fill: "#53639B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1245 20.092C23.1245 20.7803 22.9868 21.3846 22.7115 21.9046C22.4362 22.4247 22.0537 22.8607 21.5642 23.2125C21.0901 23.5643 20.5317 23.832 19.8893 24.0156C19.2621 24.1991 18.5891 24.2909 17.8701 24.2909H10V8H18.7191C19.2851 8 19.7975 8.12237 20.2564 8.36712C20.7153 8.61187 21.1054 8.93309 21.4266 9.33081C21.7478 9.71322 21.9926 10.1568 22.1608 10.6616C22.3444 11.1511 22.4362 11.6482 22.4362 12.153C22.4362 12.9485 22.2373 13.698 21.8396 14.4016C21.4419 15.09 20.8606 15.6024 20.0958 15.939C21.0289 16.2143 21.7631 16.7114 22.2985 17.4304C22.8492 18.134 23.1245 19.0212 23.1245 20.092ZM19.9352 19.4954C19.9352 19.2048 19.8816 18.9294 19.7745 18.6694C19.6828 18.3941 19.5527 18.157 19.3845 17.9581C19.2162 17.7592 19.0174 17.6063 18.7879 17.4992C18.5585 17.3768 18.3061 17.3156 18.0307 17.3156H13.1664V21.6064H17.8701C18.1608 21.6064 18.4284 21.5528 18.6732 21.4457C18.9332 21.3387 19.155 21.1933 19.3386 21.0098C19.5222 20.8109 19.6675 20.5815 19.7745 20.3214C19.8816 20.0614 19.9352 19.7861 19.9352 19.4954ZM13.1664 10.7075V14.8146H17.3883C17.9237 14.8146 18.3749 14.6311 18.742 14.264C19.1244 13.8969 19.3156 13.3921 19.3156 12.7496C19.3156 12.1224 19.1397 11.6253 18.7879 11.2582C18.4514 10.8911 18.0307 10.7075 17.5259 10.7075H13.1664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -19.1619,
    y: -17.6536,
    width: 70.3234,
    height: 70.3234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.50811
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58084
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7.2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooklaBusinessLogoSquare);
export default __webpack_public_path__ + "static/media/bookla_business_logo_square.69d5467bc88b4afeb5ceedda0ae85936.svg";
export { ForwardRef as ReactComponent };